import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userToken = JSON.parse(localStorage.getItem("userToken"));

  const initialUser = userData ? userData?.username : null;
  const initialToken = userToken ? userToken : null

  const [user, setUser] = useState(initialUser);
  const [token, setToken] = useState(initialToken);

  return (
    <AuthContext.Provider value={{ user, setUser, token, setToken}}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
